import {AccessibilityRole, Platform, TextProps} from "react-native";

type TextA11yRoles = TextProps["accessibilityRole"];
const missingOnNative = ["label", "listitem", "heading"];
export function filterA11yRoleByPlatform(role: string): TextA11yRoles {
  switch (Platform.OS) {
    case "android":
    case "ios":
      if (missingOnNative.indexOf(role) > -1) return undefined;
      return role as TextA11yRoles;
    default:
      return role as TextA11yRoles;
  }
}

// Returns "button" on native but undefined on web to prevent nested <button> elements
// which are invalid HTML and cause React 19 hydration errors.
export function containerButtonRole(): AccessibilityRole | undefined {
  return Platform.OS === "web" ? undefined : "button";
}
